<div *ngIf="message">
  <ami-dialog-message [setting]="message"></ami-dialog-message>
</div>
<p-toast></p-toast>
<div class="grid flex">
  <div class="col-12">
    <div class="card">
      <div class="surface-section px-4 py-5 md:px-2 lg:px-4">
        <div id="head" class="grid mb-3">
          <div class="col-12 md:col-11">
            <span class="block text-3xl font-medium text-900 mb-2"
              >Venta Rápida
            </span>
          </div>
          <div class="col-12 md:col-1">
            <pg-cart-sale></pg-cart-sale>
          </div>
        </div>
        <p-steps
          [model]="items"
          [(activeIndex)]="activeIndex"
          [readonly]="true"
        >
        </p-steps>
        <div class="grid justify-content-between mt-2">
          <p-button
            class="p-1"
            label="Anterior"
            (onClick)="prevPage()"
            icon="pi pi-angle-left"
            [disabled]="!(activeIndex > 0)"
          ></p-button>
          <p-button
            class="p-1"
            label="Siguiente"
            (onClick)="nextPage()"
            icon="pi pi-angle-right"
            iconPos="right"
            [disabled]="!(items.length - 1 > activeIndex) || isCartEmpty()"
          ></p-button>
        </div>
      </div>
      <div *ngIf="activeIndex === 0" class="field col-12">
        <pg-products-sale [branchStoreId]="branchStoreId"></pg-products-sale>
      </div>
      <div *ngIf="activeIndex === 1" class="field col-12">
        <div class="grid">
          <div class="col-12 md:col-6">
            <div class="grid">
              <div class="col-12 md:col-6">
                <pg-receipt-sale></pg-receipt-sale>
              </div>
              <div class="col-12 md:col-6">
                <pg-payment-sale></pg-payment-sale>
              </div>
              <div class="col-12 md:col-12" *ngIf="showBackMoney">
                <pg-money-back-sale></pg-money-back-sale>
              </div>
              <div class="col-12 md:col-12" *ngIf="!showBackMoney">
                <div class="surface-card p-5 m-3 shadow-1 border-round">
                  <div class="font-medium text-2xl text-700 mb-3">
                    <i class="pi pi-dollar"></i>
                    Módulo de Cambio
                  </div>
                    <ul class="list-none p-0 m-0">
                      <li
                        class="flex align-items-center py-3 px-2 border-top-1 surface-border flex-wrap"
                      >
                        <div class="text-500 w-2 md:w-5 font-medium">Total Venta</div>
                        <div class="text-900 w-full ml-1 md:w-6 md:flex-order-0 flex-order-1">
                          S/. {{ amountSale }}
                        </div>
                      </li>
                    </ul>
                </div>
              </div>
            </div>
          </div>
          <div class="col-12 md:col-6">
            <div class="grid">
              <div class="col-12">
                <pg-client-sale></pg-client-sale>
              </div>
              <div
                class="col-12 flex justify-content-center align-items-center"
              >
                <button
                  pButton
                  pRipple
                  class="p-button p-button-primary text-xl"
                  label="Realizar Venta"
                  (click)="confirmSale()"
                  icon="pi pi-check"
                  iconPos="right"
                  pTooltip="Confirmar"
                ></button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<p-sidebar
  [showCloseIcon]="true"
  [closeOnEscape]="true"
  *ngIf="isDialogVoucherOpen"
  [(visible)]="isDialogVoucherOpen"
  [fullScreen]="true"
  (onHide)="isDialogVoucherOpen = false"
>
  <pg-voucher-sale [dataForVoucher]="dataForVoucher"> </pg-voucher-sale>
</p-sidebar>
